import Image from "next/image";

export const DEXS = [
  {
    id: 1,
    name: "Gate",
    link: "https://www.gate.com/trade/SPON_USDT",
    logo: <Image height={24} width={24} src="/logos/gate.svg" alt="" />,
  },
  {
    id: 2,
    name: "MEXC",
    link: "https://www.mexc.com/exchange/SPON_USDT",
    logo: <Image height={24} width={24} src="/logos/mexc.svg" alt="" />,
  },
  {
    id: 3,
    name: "Bitget",
    link: "https://www.bitget.com/spot/SPONUSDT",
    logo: <Image height={24} width={24} src="/logos/bitget.svg" alt="" />,
  },
  {
    id: 4,
    name: "Lbank",
    link: "https://www.lbank.com/trade/spon_usdt",
    logo: <Image height={24} width={24} src="/logos/lbank.webp" alt="" />,
  },
];
